const vuetifyColors = {
    'amber': '#ffc107',
    'blue': '#2196f3',
    'blue-grey': '#607d8b',
    'brown': '#795548',
    'cyan': '#00bcd4',
    'deep-orange': '#ff5722',
    'deep-purple': '#673ab7',
    'green': '#4caf50',
    'grey': '#9e9e9e',
    'indigo': '#3f51b5',
    'light-blue': '#03a9f4',
    'light-green': '#8bc34a',
    'lime': '#cddc39',
    'orange': '#ff9800',
    'pink': '#e91e63',
    'purple': '#9c27b0',
    'red': '#f44336',
    'teal': '#009688',
    'yellow': '#ffeb3b',
};
export const vuetifyColorsToRGB = (color) => {
    return vuetifyColors[color];
};
